<script setup>
    import { nextTick, ref, watch } from 'vue';
    import { storeToRefs } from 'pinia';
    import { useI18n } from 'vue-i18n';
    import { useSearchStore } from '../store/useSearchStore';

    defineEmits(['update:model-value']);

    const { t } = useI18n();
    const store = useSearchStore();
    const inputRef = ref(null);

    const handleResetSearch = () => {
        store.resetSearch();
        nextTick(() => {
            store.updateUrlParameters();
            inputRef.value.focus();
        });
    };

    const { productSearchMode } = storeToRefs(store);
    watch(productSearchMode, (value, oldValue) => {
        if (oldValue === true && value === false && !store.hasResults) {
            nextTick(() => {
                inputRef.value.focus();
            });
        }
    });
</script>

<template>
    <span class="search__query">
        <input
            id="search-input"
            ref="inputRef"
            v-model="store.searchQuery"
            type="search"
            class="search__input"
            :autofocus="true"
            :placeholder="t('search_searchviewInputLabel')"
        />
        <button class="search__reset" aria-label="Reset search" @click.prevent="() => handleResetSearch()">
            <span class="icon">
                <svg width="14px" height="14px">
                    <use xlink:href="#search-icon-close"></use>
                </svg>
            </span>
        </button>
    </span>
</template>

<style lang="scss">
    @import '../../../../scss/variables';
    @import '../../../../scss/utilities/all';

    .search {
        &__query {
            display: inline-flex;
            padding: 0.5rem 0.75rem;
            gap: 1rem;
            border-radius: 4px;
            background-color: rgba($white, 0.1);
        }

        &__reset {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            background: transparent;
            border: 0 none;
            color: rgba($white, 0.54);
            cursor: pointer;
            transition: color $speed ease-out;
            margin-left: -0.875rem;

            &:hover {
                color: $white;
            }
        }
    }
</style>
